module.exports = __webpack_public_path__ + "static/media/mv-GLOBO.425bd1d7.svg";